import { render } from "./ClubLives.vue?vue&type=template&id=65c17638&scoped=true"
import script from "./ClubLives.vue?vue&type=script&lang=js"
export * from "./ClubLives.vue?vue&type=script&lang=js"

import "./ClubLives.vue?vue&type=style&index=0&id=65c17638&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c17638"]])

export default __exports__